document.addEventListener('DOMContentLoaded', function() {
  const articleContent = document.getElementById('article-content');
  const tocList = document.getElementById('toc-list');
  const progressBar = document.getElementById('reading-progress-bar');
  
  if (!articleContent || !tocList) return;

  // 1. Generate Table of Contents
  const allHeaders = articleContent.querySelectorAll('h2, h3');
  // Filter out empty headers
  const headers = Array.from(allHeaders).filter(header => header.textContent.trim().length > 0);
  
  if (headers.length === 0) {
    document.querySelector('.news-article-sidebar').style.display = 'none';
    return;
  }

  headers.forEach((header, index) => {
    // Create ID if not exists
    if (!header.id) {
      header.id = 'section-' + index;
    }

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + header.id;
    a.textContent = header.textContent;
    a.classList.add('toc-link');
    
    // Add class for indentation based on tag name
    if (header.tagName.toLowerCase() === 'h3') {
      li.classList.add('toc-subitem');
    }
    
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const offset = 100;
      const elementPosition = header.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });

    li.appendChild(a);
    tocList.appendChild(li);
  });

  // 2. Reading Progress & Active Link
  function updateProgress() {
    const contentBox = articleContent.getBoundingClientRect();
    const contentTop = contentBox.top + window.scrollY;
    const contentHeight = contentBox.height;
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;

    // Calculate percentage
    // 0% when top of content is near top of screen (accounting for header)
    // 100% when bottom of content is visible
    
    let percent = 0;
    
    // Offset for sticky header or top spacing
    const offset = 150; 
    const startPoint = contentTop - windowHeight + offset; 
    // Actually, we want 0% when we START reading. 
    // Usually that means the top of the article is at the top of the viewport.
    // But users often want to see the bar move as soon as they scroll past the header.
    
    // Let's define:
    // 0% = Top of article is at (Window Height * 0.8) - i.e. just entered and moved up a bit
    // 100% = Bottom of article is at Bottom of Window
    
    const effectiveStart = contentTop - windowHeight + 100; 
    const effectiveEnd = contentTop + contentHeight - windowHeight;
    const totalScrollableDistance = effectiveEnd - effectiveStart;

    if (totalScrollableDistance <= 0) {
        percent = 100;
    } else {
        percent = ((scrollY - effectiveStart) / totalScrollableDistance) * 100;
    }
    
    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;
    
    if (progressBar) {
      // Check if we are in mobile mode (horizontal bar) or desktop (vertical bar)
      // Must match CSS media query (max-width: 989px)
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      
      if (isMobile) {
         progressBar.style.width = percent + '%';
         progressBar.style.height = '100%';
      } else {
         progressBar.style.height = percent + '%';
         progressBar.style.width = '100%';
      }
    }

    // Highlight active TOC item
    let activeId = null;
    headers.forEach(header => {
      const rect = header.getBoundingClientRect();
      if (rect.top < windowHeight / 3) {
        activeId = header.id;
      }
    });

    document.querySelectorAll('.toc-link').forEach(link => {
      link.classList.remove('active');
      if (activeId && link.getAttribute('href') === '#' + activeId) {
        link.classList.add('active');
      }
    });
  }

  window.addEventListener('scroll', updateProgress);
  updateProgress(); // Initial call
});
